import { Component, OnInit } from '@angular/core';

import { LeadSellerPreferencesService } from '../../services/lead-seller-preferences/lead-seller-preferences.service';
import { Observable } from 'rxjs';
import { selectAllMembersSelected, selectDealerGroupCount } from '../../services/lead-seller-group/reducer';
import { LeadSellerGroupService } from '../../services/lead-seller-group/lead-seller-group.service';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  DealerGroupSectionComponent
} from '../dealer-group-section/dealer-group-section.component';
import { TrackDirective } from 'remarketing-ui-components-lib';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-preferences-popover',
    templateUrl: './preferences-popover.component.html',
    styleUrls: ['./preferences-popover.component.scss'],
    imports: [TranslocoDirective, DealerGroupSectionComponent, TrackDirective, CommonModule]
})
export class PreferencesPopoverComponent implements OnInit {
  preferencesState$ = this.leadSellerPreferencesService.state$;

  dealerGroups$ = this.leadSellerPreferencesService.state$;
  readonly allSelected$: Observable<boolean> = this.leadSellerPreferencesService.select(selectAllMembersSelected);
  dealershipGroupCount = 0;

  constructor(
    private leadSellerPreferencesService: LeadSellerPreferencesService,
    private leadSellerGroupService: LeadSellerGroupService
  ) {}

  ngOnInit() {
    this.leadSellerGroupService.search('');
    this.leadSellerGroupService.select(selectDealerGroupCount).subscribe(groupCount => {
      this.dealershipGroupCount = groupCount;
    });
  }

  toggleAll() {
    this.leadSellerPreferencesService.toggleAll();
  }

  search(e) {
    this.leadSellerGroupService.search(e.target.value.toLowerCase().trim());
  }

  toggleGroup(groupUuid: string) {
    this.leadSellerPreferencesService.toggleGroup(groupUuid);
  }

  toggleMember(uuid: string) {
    this.leadSellerPreferencesService.toggleMember(uuid);
  }

  get isSellerAssociatedToMultipleLeadSellerGroup() {
    return this.dealershipGroupCount && this.dealershipGroupCount > 1;
  }
}
